<!-- Base.PageHeader.vue (client-lms) -->
<template>
  <div class="lms_page_header">
    <h2 class="lms_page_header_title">{{ title }}</h2>
    <div v-if="$slots.default" class="lms_page_header_actions">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
});
</script>
